<tt-form-field-base
    [ttFieldId]="id.input"
    [ttLabel]="ttLabel"
    [ttLabelView]="ttLabelView"
    [ttTranslateLabel]="ttTranslateLabel"
    [ttSublabel]="ttSublabel"
    [ttTranslateSublabel]="ttTranslateSublabel"
    [ttToggleTipText]="ttToggleTipText"
    [ttTranslateToggleTipText]="ttTranslateToggleTipText"
    [ttRequired]="ttRequired"
    [ttReadonly]="ttReadonly"
    [ttDisabled]="ttDisabled"
    [ttStyle]="ttStyle"
    ttInputType="file-uploader"
>
    <div style="display: flex; flex-direction: column; width: 100%; height: fit-content; gap: 0.4rem">
        <label *ngIf="!ttDropZone" class="tt-button tt-button--primary col-xs-2" style="padding: 0.6rem 0rem; text-align: center; margin: 0; min-width: 16rem">
            {{ filetranslations["select_files"] }}
            <input type="file" [hidden]="true" style="display: none" (change)="onFileChanged($event)" [multiple]="ttMultiple" [accept]="ttAccept" />
        </label>
        <div
            *ngIf="ttDropZone"
            class="tt-file-uploader__drop-zone"
            (dragover)="onDragover($event)"
            (dragleave)="onDragleave($event)"
            (dragend)="onDragleave($event)"
            (drop)="onFilesDropped($event)"
            [ngStyle]="style['dropzone']"
        >
            <label class="tt-file-uploader__drop-label" [ngStyle]="style['dropzone_label']">
                {{ filetranslations["drag_and_drop_or_click"] }}
                <input #inputRef type="file" [hidden]="true" style="display: none" (change)="onFileChanged($event)" [multiple]="ttMultiple" [accept]="ttAccept" />
            </label>
        </div>
        <ul class="tt-file-uploader__list">
            <li *ngFor="let row of displayRows; trackBy: trackDisplayRow" class="tt-file-uploader__item">
                <div class="tt-file-uploader__file">
                    <span *ngIf="!!getDisplayRowStatusIcon(row)" class="tt-file-uploader__status" [ngClass]="getDisplayRowStatusIcon(row)"></span>
                    <span class="tt-file-uploader__file-text-content" [matTooltip]="getDisplayRowTooltip(row)" matTooltipShowDelay="1000">
                        <span class="tt-file-uploader__file-name">{{ getDisplayRowLabel(row) }}</span>
                        <span *ngIf="isDisplayRowError(row)" class="tt-file-uploader__file-name tt-file-uploader__file-name--error">{{ $any(row).errorMessage }}</span>
                    </span>
                    <button class="tt-button tt-file-uploader__remove" (click)="removeDisplayRow(row)" style="color: var(--tt-body-text-color)">
                        <span class="far fa-times"></span>
                    </button>
                </div>
                <ul *ngIf="hasOutlookMailAttachmentRows(row)" class="tt-file-uploader__attachment-list">
                    <li
                        *ngFor="let attachmentRow of $any(row).attachments; trackBy: trackOutlookMailAttachmentRow"
                        class="tt-file-uploader__attachment-row"
                        [class.tt-file-uploader__attachment-row--removed]="attachmentRow.removed"
                    >
                        <span class="tt-file-uploader__status far fa-paperclip"></span>
                        <span class="tt-file-uploader__file-text-content" [matTooltip]="getOutlookMailAttachmentLabel(attachmentRow)" matTooltipShowDelay="1000">
                            <span class="tt-file-uploader__file-name">{{ getOutlookMailAttachmentLabel(attachmentRow) }}</span>
                        </span>
                        <button
                            *ngIf="!attachmentRow.removed"
                            class="tt-button tt-file-uploader__remove"
                            (click)="removeOutlookMailAttachment($any(row), attachmentRow)"
                            style="color: var(--tt-body-text-color)"
                        >
                            <span class="far fa-times"></span>
                        </button>
                        <button
                            *ngIf="attachmentRow.removed"
                            class="tt-button tt-file-uploader__remove"
                            (click)="restoreOutlookMailAttachment($any(row), attachmentRow)"
                            style="color: var(--tt-body-text-color)"
                        >
                            <span class="far fa-undo"></span>
                        </button>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</tt-form-field-base>
